(ns fx.timer
  (:require [common.time :as c-time]
            [re-frame.core :as rf]
            [re-frame.db :as rf.db]))

(def CLOCK_KEY :now-ms)

(def HANDLE_KEY :clock-handle)

;; Every second, dispatch current time
(rf/reg-event-fx
 ::start-clock
 (fn [_]
   (let [existing (get @rf.db/app-db HANDLE_KEY)]
     (when-not existing
       (let [h (js/setInterval
                #(rf/dispatch [:clock/tick (c-time/now-millis)])
                1000)]
         (rf/dispatch [:clock/store-handle h]))))))

;; Store time in app-db
(rf/reg-event-db
 :clock/tick
 (fn [db [_ now]]
   (assoc db CLOCK_KEY now)))

(rf/reg-event-db
 :clock/store-handle
 (fn [db [_ handle]]
   (assoc db HANDLE_KEY handle)))

(rf/reg-sub
 ::now
 (fn [db _]
   (get db CLOCK_KEY)))
